import { STATS_METRICS } from "@/helpers/charts";
import inputsDictionary from "@/settings/inputsDictionary";
import { InputDictionary } from "@/types/common";

const createStatisticDictionaryExtension = () => {
  const dictionaryExtension: InputDictionary[] = [];
  inputsDictionary.displayMetrics.forEach((el) => {
    STATS_METRICS.forEach((statEl) => {
      dictionaryExtension.push({
        ...el,
        title: `${el.title} (${statEl})`,
        value: `${el.value}_${statEl}`,
      });
    });
  });
  return dictionaryExtension;
};
export const metricsDictionary: InputDictionary[] = [
  ...inputsDictionary.displayMetrics,
  ...createStatisticDictionaryExtension(),
  ...inputsDictionary.dimensionMetrics,
  ...inputsDictionary.timeMetrics,
];
